import { Injectable } from '@angular/core';
import { GoogleAuthService } from '../auth/google-auth.service';
import { CalendarIntegrationEvent, CalendarIntegrationProvider } from './interfaces/calendar-integration.interface';

@Injectable({
  providedIn: 'root'
})
export class CalendarIntegrationService implements CalendarIntegrationProvider {

  constructor(
    private googleAuthService: GoogleAuthService,
  ) { }

  async init(): Promise<void> {
    await this.googleAuthService.init();
  }

  async signIn(): Promise<void> {
    return this.googleAuthService.signIn();
  }
 
  async signOut(): Promise<void> {
    return this.googleAuthService.signOut();
  }

  getAccessToken(): string {
    return this.googleAuthService.getAccessToken();
  }

  isAuthenticated(): boolean {
    return this.googleAuthService.isAuthenticated();
  }

  async createEvent(event: CalendarIntegrationEvent): Promise<CalendarIntegrationEvent> {
    return this.googleAuthService.createEvent(event);
  }

  async updateEvent(eventId: string, event: CalendarIntegrationEvent): Promise<CalendarIntegrationEvent> {
    return this.googleAuthService.updateEvent(eventId, event);
  }

  async deleteEvent(eventId: string): Promise<boolean> {
    return this.googleAuthService.deleteEvent(eventId);
  }

  async getEvents(start: number, end: number): Promise<CalendarIntegrationEvent[]> {
    
    if (this.googleAuthService.isAuthenticated()) {
      return this.googleAuthService.getEvents(start, end);
    } 
   
  }


}
